import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class RepaymentReportSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "startDate",
        label: "Loan Start Date",
        type: "date",
        placeholder: "Loan Start Date",
        required: true,
      },
      {
        name: "endDate",
        label: "Loan End Date",
        type: "date",
        placeholder: "Loan End Date",
        required: true,
      },
      {
        name: "loanPaymentMode",
        label: "Repayment Type",
        type: "select",
        options: _enum.REPAYMENT_TYPE_KEY,
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { downloadFile } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <div className="action_btn_group">
          <button
            type="button"
            className="btn btn-primary"
            onClick={(...args) => downloadFile(...args)}
          >
            <i className="fa fa-download me-2"></i>
            Download Excel
          </button>
        </div>
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(RepaymentReportSearch);
